import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConnectGoogleAnalyticsPage = lazy(
  () => import('~/features/onboarding/pages/connect-google-analytics-screen'),
);

/** `connectionId` present → edit an existing GA4 connection (prefill + PATCH);
 *  absent → the normal create flow. */
const searchSchema = z.object({
  connectionId: z.string().optional(),
});

function ConnectGoogleAnalyticsRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectGoogleAnalyticsPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-analytics/',
)({
  validateSearch: searchSchema,
  component: ConnectGoogleAnalyticsRouteComponent,
});
